// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv.nppfs-keypad-div {\n  position: absolute;\n  width: 0px;\n  height: 0px;\n  white-space: normal;\n  overflow: visible;\n}\n", ""]);
// Exports
module.exports = exports;
